import React from 'react';
import { observer } from 'mobx-react-lite';
import youWinImg from '../../assets/images/turbo-blackjack/logo-you-win-2.png';
import { winningAmountStore } from '../../store/winningAmountStore';

const TerminalWinPopup = observer(() => {
  const { winningAmount } = winningAmountStore;

  if (!winningAmount) {
    return null;
  }

  return (
    <div className='tb-win-popup-holder'>
      <div className='tb-win-popup-image'>
        <img src={youWinImg} alt='' />
        <p className='tb-win-popup-txt'>10000000 amd</p>
      </div>
    </div>
  );
});

export default TerminalWinPopup;
